import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-notification-tile',
  templateUrl: './notification-tile.component.html',
  styleUrls: ['./notification-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationTileComponent {
  @Input() lastStatusChanged: string;
}
